export const SET_CONNECTION_FLAG = "SET_CONNECTION_FLAG";
export const STORE_WIFI_DETAILS = "STORE_WIFI_DETAILS";
